import React from "react";
import {
  Box,
  Container,
  Divider,
  Link,
  LinkProps,
  List,
  ListItem,
  Stack,
  Text,
} from "@chakra-ui/react";
import { CONTAINER_MAX_WIDTH } from "./Layout";
import { communityLinks } from "../pages/community";

const FooterLink = ({ children, ...props }: LinkProps) => {
  return (
    <Link
      {...props}
      isExternal
      onClick={() => {
        window.gtag?.("event", "footer_link_click", {
          title: String(children), // force to string in case child element is wrapped in a box or something
        });
      }}
    >
      {children}
    </Link>
  );
};

export function Footer() {
  const FOOTER_HEIGHT = 200;
  return (
    <Box
      width="full"
      bg={"white"}
      borderWidth="1px 0 0 0"
      borderStyle="solid"
      borderColor="silver.400"
      minH={FOOTER_HEIGHT}
    >
      <Container
        maxW={CONTAINER_MAX_WIDTH}
        py="2"
        pt="6"
        fontSize="sm"
        color={"gray.500"}
        sx={{
          a: {
            fontWeight: "400",
          },
        }}
      >
        <Stack spacing={4} justify={"center"} minH={FOOTER_HEIGHT}>
          <Stack
            justify={"space-between"}
            direction={{ base: "column", lg: "row" }}
            spacing={12}
          >
            <Stack w={{ base: "100%", lg: "40%" }} spacing={3}>
              <Text color="gray.800" variant="bodySm" fontWeight="600">
                About
              </Text>
              <Text variant="bodySm">
                GraphQL.com is maintained by the{" "}
                <FooterLink
                  href="https://www.apollographql.com?utm_campaign=graphql.com"
                  isExternal
                >
                  Apollo
                </FooterLink>{" "}
                team. Our goal is to give developers and technical leaders
                the tools they need to understand and
                adopt GraphQL.
              </Text>
            </Stack>
            <Stack
              w={{ base: "100%", lg: "50%" }}
              direction={{ base: "column", md: "row" }}
              justifyContent="space-between"
            >
              <Stack w={{ base: "100%", lg: "32%", xl: "20%" }} spacing={1}>
                <Text color="gray.800" variant="bodySm" fontWeight="600">
                  Sites
                </Text>
                <List>
                  <ListItem>
                    <FooterLink href="https://www.apollographql.com?utm_campaign=graphql.com">
                      Apollo
                    </FooterLink>
                  </ListItem>
                  <ListItem>
                    <FooterLink href="https://principledgraphql.com?utm_campaign=graphql.com">
                      Principled GraphQL
                    </FooterLink>
                  </ListItem>
                  <ListItem>
                    <FooterLink href="https://www.apollographql.com/tutorials?utm_campaign=graphql.com">
                      Odyssey
                    </FooterLink>
                  </ListItem>
                </List>
              </Stack>
              <Stack w={{ base: "100%", lg: "32%", xl: "20%" }} spacing={1}>
                <Text color="gray.800" variant="bodySm" fontWeight="600">
                  Tools
                </Text>
                <List>
                  <ListItem>
                    <FooterLink href="https://studio.apollographql.com/sandbox/explorer?utm_campaign=graphql.com">
                      Sandbox
                    </FooterLink>
                  </ListItem>
                  <ListItem>
                    <FooterLink href="https://github.com/chentsulin/awesome-graphql">
                      Awesome GraphQL
                    </FooterLink>
                  </ListItem>
                </List>
              </Stack>
              <Stack w={{ base: "100%", lg: "32%", xl: "20%" }} spacing={1}>
                <Text color="gray.800" variant="bodySm" fontWeight="600">
                  Community
                </Text>
                <List>
                  {communityLinks.map((link, key) => (
                    <ListItem key={key}>
                      <FooterLink isExternal href={link.url}>
                        {link.title}
                      </FooterLink>
                    </ListItem>
                  ))}
                </List>
              </Stack>
            </Stack>
          </Stack>
          <Divider pt="2" />
          <Text variant="bodySm">GraphQL.com {new Date().getFullYear()}</Text>
        </Stack>
      </Container>
    </Box>
  );
}
